import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=30adb3fb&"
import script from "./CatalogList.vue?vue&type=script&lang=js&"
export * from "./CatalogList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=30adb3fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports